import styled, { FlattenSimpleInterpolation, css } from 'styled-components';

export const AppStores = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 0 0 0 0;

  & > * {
    margin: 0 0 0 0.5rem;

    &:first-of-type {
      margin-left: 0;
    }
  }
`;

const baseBadgeStyles = css`
  display: flex;
  justify-content: center;
  align-content: center;
  background: transparent;
  border-radius: ${Styles.borderRadius};

  a {
    display: flex;
    justify-content: center;
    align-items: center;
  }
`;

export const AppStoreBadgeContainer = styled.div<{ badgeStyles?: FlattenSimpleInterpolation }>`
  ${baseBadgeStyles}
  ${Styles.mobile`
    display: ${~navigator.appVersion.indexOf('Android') ? 'none' : 'block'};
  `}

  ${props => props.badgeStyles}
`;

export const GooglePlayBadgeContainer = styled.div<{ badgeStyles?: FlattenSimpleInterpolation }>`
  ${baseBadgeStyles}
  ${props => props.badgeStyles}
`;

export const ConfettiLeft = styled.div`
  position: absolute;
  width: 110px;
  top: 0;
  right: calc(50% + 90px);
  transform: translate(0%, -130%);

  ${Styles.desktop`
    right: auto;
    left: 0%;
    width: 25%;
    width: 25%;
    top: 50%;
    transform: translate(-125px, -75px);
  `}
`;

export const ConfettiRight = styled.div`
  position: absolute;
  width: 140px;
  top: 0;
  left: calc(50% + 110px);
  transform: translate(0%, -200%);

  ${Styles.desktop`
    left: auto;
    right: 0%;
    width: 33%;
    transform: translate(165px, 32px);
  `}
`;
